import React from 'react'
import Community from './Community'

const CommunityPage = () => {
  return (
    <div style={{paddingTop : '10vw'}}><Community/></div>
  )
}

export default CommunityPage